import { render, staticRenderFns } from "./ExtAddress.vue?vue&type=template&id=025213c2"
import script from "./ExtAddress.vue?vue&type=script&lang=js"
export * from "./ExtAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports